import React, { useEffect, useState } from 'react'
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
  withRouter
} from 'react-router-dom'
import { Profile } from 'common/enum/profile'
import { isMaintenanceAccessBlockEnabled } from 'common/utils/feature-flags'
import { useStores } from 'presentation/hooks/use-stores'
import AddProfessional from 'presentation/doctor/pages/AddProfessional'
import makePatientLogin from 'main/factories/pages/patient/login/patient-login-factory'
import makePasswordRecovery from 'main/factories/pages/patient/password-recovery/patient-password-recovery-factory'
import makeDoctorSignup from 'main/factories/pages/doctor/signup/doctor-signup-factory'
import makeDoctorIndicationRegister from 'main/factories/pages/doctor/doctor-indication/doctor-indication-register-factory'
import DoctorHome from 'presentation/doctor/pages/Home'
import makeDoctorAddSecretary from 'main/factories/pages/doctor/add-secretary/doctor-add-secretary-factory'
import makeDoctorSecretaries from 'main/factories/pages/doctor/secretaries/doctor-secretaries-factory'
import makeDoctorSecretaryDetails from 'main/factories/pages/doctor/secretary-details/doctor-secretary-details-factory'
import makeDoctorAddSignature from 'main/factories/pages/doctor/add-signature/doctor-add-signature-factory'
import makeDoctorSignature from 'main/factories/pages/doctor/signature/doctor-signature-factory'
import PrivateRoute from 'presentation/shared/components/PrivateRoute'
import Allergies from 'presentation/doctor/pages/Allergies'
import makeDoctorAddAllergy from 'main/factories/pages/doctor/add-allergy/doctor-add-allergy-factory'
import makeDoctorAddSurgicalOrderInfo from 'main/factories/pages/doctor/add-surgical-order-info/doctor-add-surgical-oder-info-factory'
import makePatientSaveSurgicalOrderPersonalInfo from 'presentation/shared/pages/create-surgical-order/save-personal-info/save-surgical-order-personal-info'
import makePatientSaveSurgicalOrderInsuranceInfo from 'presentation/shared/pages/create-surgical-order/save-insurance-info'
import makeDoctorSelectTherapeuticPlan from 'main/factories/pages/doctor/add-therapeutic-plan/select-therapeutic-plan'
import makeDoctorCreateTherapeuticPlan from 'main/factories/pages/doctor/add-therapeutic-plan/create-therapeutic-plan'
import makeDoctorTherapeuticPlanResume from 'main/factories/pages/doctor/add-therapeutic-plan/therapeutic-plan-resume'
import makeDoctorTherapeuticPlanDiagnosis from 'main/factories/pages/doctor/add-therapeutic-plan/therapeutic-plan-diagnosis'
import makeDoctorTherapeuticPlanAttachments from 'main/factories/pages/doctor/add-therapeutic-plan/therapeutic-plan-attachments'
import makeDoctorAnswerPendency from 'main/factories/pages/doctor/pendency/doctor-pendency-factory'
import makeDoctorPersonalInfo from 'main/factories/pages/doctor/personal-info/doctor-personal-info-Factory'
import { AppendSurgicalOrderDocument } from 'presentation/shared/pages/AppendSurgicalOrderDocument'
import { MedicalReports } from 'presentation/shared/pages/MedicalReports'
import PatientProfileLayout from 'presentation/patient/layouts/Profile'
import SurgeryDetails from 'presentation/shared/pages/SurgeryDetails'
import SurgicalOrderDocuments from 'presentation/doctor/pages/SurgicalOrderDocuments'
import TherapeuticPlanProposedProtocol from 'presentation/doctor/pages/AddTherapeuticPlan/TherapeuticPlanProposedProtocol'
import { Pendencies } from 'presentation/doctor/pages/Pendencies'
import makeOnboarding from 'main/factories/pages/doctor/onboarding/onboarding-factory'
import UserTerms from 'presentation/shared/pages/UserTerms'
import makeSurgicalSchedulingPages from 'main/factories/pages/doctor/surgical-scheduling/surgical-scheduling-factory'
import SurgicalSchedulingDetails from 'presentation/doctor/pages/SurgicalSchedulingDetails'
import makeSurgicalOrder from 'main/factories/pages/doctor/surgical-order/surgical-order-factory'
import makeSurgicalOrderDashboard from 'main/factories/pages/doctor/surgical-order/surgical-order-dashboard-factory'
import SecretaryDoctors from 'presentation/doctor/pages/SecretaryDoctors'
import makeDoctorUpdatePassword from 'main/factories/pages/doctor/update-password/doctor-personal-info-Factory'
import CooperativeForm from 'presentation/doctor/pages/CooperativeForm'
import SelectLocation from 'presentation/doctor/pages/AddSurgicalOrderNew/SelectLocation'
import AddPatientNew from 'presentation/doctor/pages/AddPatientNew'
import SelectPatient from 'presentation/doctor/pages/AddSurgicalOrderNew/SelectPatient'
import ReviewPatient from 'presentation/doctor/pages/AddSurgicalOrderNew/ReviewPatient'
import OpenSurgicalOrder from 'presentation/doctor/pages/AddSurgicalOrderNew/OpenSurgicalOrder'
import ReportsAndDocuments from 'presentation/doctor/pages/AddSurgicalOrderNew/ReportsAndDocuments'
// import ReportsAndDocumentsV2 from 'presentation/doctor/pages/AddSurgicalOrderV2/ReportsAndDocuments'
import SelectProceduresAndCID from 'presentation/doctor/pages/AddSurgicalOrderNew/SelectProceduresAndCID'
import ReviewSurgicalOrder from 'presentation/doctor/pages/ReviewSurgicalOrder'
import SurgicalOrderCreated from 'presentation/doctor/pages/SurgicalOrderCreated'
import SelectOPME from 'presentation/doctor/pages/AddSurgicalOrderNew/SelectOPME'
import SelectAnesthesiology from 'presentation/doctor/pages/AddSurgicalOrderNew/SelectAnesthesiology'
import AddClinicalHistoryAndRecord from 'presentation/doctor/pages/AddSurgicalOrderNew/AddClinicalHistoryAndRecord'
import SurgicalOrderIntegration from 'presentation/doctor/pages/SurgicalOrderIntegration'
import { LocalStorageAdapter } from 'infra/storage-adapter/storage-adapter'
import MyProductivity from 'presentation/doctor/pages/MyProductivity'
import makeAmbulatoryAuthorizationPage from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import AddPatientDefault from 'presentation/doctor/pages/AddPatientDefault'
// import RegistrationInfo from 'presentation/doctor/pages/AddSurgicalOrderV2/RegistrationInfo'
// import ProceduresAndOpme from 'presentation/doctor/pages/AddSurgicalOrderV2/ProceduresAndOpme'
// import ClinicalHistory from 'presentation/doctor/pages/AddSurgicalOrderV2/ClinicalHistory'
import AddSurgicalOrderV2 from 'presentation/doctor/pages/AddSurgicalOrderV2'
import SuccessAddSurgicalOrder from 'presentation/doctor/pages/AddSurgicalOrderV2/SuccessAddSurgicalOrder'
import MaintenanceBlock from 'presentation/shared/pages/MaintenanceBlock'

export const ScrollToTop = withRouter(() => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
})

const SwitchRouter = withRouter(() => {
  const { pathname } = useLocation()
  const stores = useStores()
  const currentUser = stores.currentAccount

  const [pendingTerms, setPendingTerms] = useState<boolean>(false)

  const isPendingTerms = currentUser
    .getCurrentAccount()
    ?.user?.terms?.some((term) => term.signed === false)

  const pendingTermsOfUse = () =>
    currentUser.getCurrentAccount()?.accessToken && isPendingTerms

  const setSurgicalOrderIntegrationUserFlag = () => {
    const localStorageAdapter = new LocalStorageAdapter()
    const currentFlags = localStorageAdapter.get('user-flags')

    if (currentFlags?.surgicalOrderIntegration === undefined) {
      localStorageAdapter.set('user-flags', {
        ...currentFlags,
        surgicalOrderIntegration: false
      })
    }
  }

  useEffect(() => {
    setPendingTerms(!!pendingTermsOfUse())
    setSurgicalOrderIntegrationUserFlag()
  }, [pathname])

  if (isMaintenanceAccessBlockEnabled()) {
    return (
      <Switch>
        <Route
          path="/servicos-temporariamente-indisponiveis"
          exact
          component={MaintenanceBlock}
        />
        <Route
          path="/*"
          component={() => (
            <Redirect to="/servicos-temporariamente-indisponiveis" />
          )}
        />
      </Switch>
    )
  }

  return (
    <>
      {pendingTerms ? (
        <Switch>
          <PrivateRoute
            path="/termos-de-uso"
            exact
            component={UserTerms}
            profile={[Profile.DOCTOR, Profile.SECRETARY]}
            pendingTerms={pendingTerms}
          />

          <Route
            path="/*"
            component={() => {
              return (
                <>
                  <Redirect to="/termos-de-uso" />
                </>
              )
            }}
          />
        </Switch>
      ) : (
        <Switch>
          <Route
            path="/"
            exact
            component={() => {
              return (
                <>
                  <Redirect
                    to={
                      currentUser.getCurrentAccount()?.accessToken
                        ? '/home'
                        : '/login'
                    }
                  />
                </>
              )
            }}
          />
          <Route
            path="/login"
            exact
            component={() => makePatientLogin(Profile.DOCTOR)}
          />
          <Route path="/cadastro/:hash" exact component={makeDoctorSignup} />
          <Route
            path="/cadastro-corpo-clinico"
            exact
            component={makeDoctorIndicationRegister}
          />
          <PrivateRoute
            path="/home"
            exact
            component={DoctorHome}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/selecionar-perfil"
            exact
            component={SecretaryDoctors}
            profile={[Profile.SECRETARY]}
          />
          <PrivateRoute
            path="/doctor-onboarding"
            exact
            component={makeOnboarding}
            profile={[Profile.DOCTOR]}
          />
          <Route
            path="/recuperar-senha/:type"
            exact
            component={() => makePasswordRecovery({ client: Profile.DOCTOR })}
          />
          <PrivateRoute
            path="/vincular-profissional"
            exact
            component={AddProfessional}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/vincular-profissional/secretaria"
            exact
            component={makeDoctorAddSecretary}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/secretaria"
            exact
            component={makeDoctorSecretaries}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/secretaria/detalhes"
            exact
            component={makeDoctorSecretaryDetails}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/assinatura/save"
            exact
            component={makeDoctorAddSignature}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/assinatura"
            exact
            component={makeDoctorSignature}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/alergia/save"
            exact
            component={makeDoctorAddAllergy}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/alergia"
            exact
            component={Allergies}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pendencias"
            exact
            component={Pendencies}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pendencia"
            exact
            component={makeDoctorAnswerPendency}
            profile={[Profile.DOCTOR]}
          />
          {/* Antigo Fluxo Criar Pedido */}
          {/* <PrivateRoute
            path="/pedido/novo"
            exact
            component={makeDoctorCreateSurgicalOrder}
            profile={[Profile.DOCTOR]}
          /> */}
          {/* Fluxo criar pedido cirúrgico - Gabarito OPME */}
          <PrivateRoute
            path="/pedido"
            component={AddSurgicalOrderV2}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido-sucesso"
            component={SuccessAddSurgicalOrder}
            profile={[Profile.DOCTOR]}
          />
          {/* Antigo fluxo criar pedido cirúrgico */}
          <PrivateRoute
            path="/novo-pedido/local"
            exact
            component={SelectLocation}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/paciente"
            exact
            component={SelectPatient}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/revisar-paciente"
            exact
            component={ReviewPatient}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/cooperativa"
            exact
            component={CooperativeForm}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/procedimentos"
            exact
            component={SelectProceduresAndCID}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/opme"
            exact
            component={SelectOPME}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/anestesiologia"
            exact
            component={SelectAnesthesiology}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/historia-clinica"
            exact
            component={AddClinicalHistoryAndRecord}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/laudos-documentos"
            exact
            component={ReportsAndDocuments}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/resumo"
            exact
            component={ReviewSurgicalOrder}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-pedido/criado"
            exact
            component={SurgicalOrderCreated}
            profile={[Profile.DOCTOR]}
          />
          {/* /Antigo fluxo criar pedido cirúrgico */}
          {/* Essa tela vai deixar de existir */}
          <PrivateRoute
            path={'/pedido-em-aberto'}
            component={OpenSurgicalOrder}
            profile={[Profile.DOCTOR]}
          />
          {/* /Essa tela vai deixar de existir */}
          <PrivateRoute
            path="/novo-paciente"
            exact
            component={AddPatientNew}
            profile={[Profile.DOCTOR]}
          />
          {/* Nova rota default (add patient): */}
          <PrivateRoute
            path="/cadastrar-novo-paciente"
            exact
            component={AddPatientDefault}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido--cirurgico"
            exact
            component={makeDoctorAddSurgicalOrderInfo}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido-cirurgico/save/dados-pessoais"
            exact
            component={makePatientSaveSurgicalOrderPersonalInfo}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido-cirurgico/save/dados-convenio"
            exact
            component={makePatientSaveSurgicalOrderInsuranceInfo}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-plano-terapeutico/selecionar-plano"
            exact
            component={makeDoctorSelectTherapeuticPlan}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-plano-terapeutico/novo"
            exact
            component={makeDoctorCreateTherapeuticPlan}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-plano-terapeutico/resumo"
            exact
            component={makeDoctorTherapeuticPlanResume}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-plano-terapeutico/diagnostico"
            exact
            component={makeDoctorTherapeuticPlanDiagnosis}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/perfil"
            exact
            component={PatientProfileLayout}
            profile={[Profile.DOCTOR, Profile.SECRETARY]}
          />
          <PrivateRoute
            path="/informacoes-pessoais"
            exact
            component={makeDoctorPersonalInfo}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/alterar-senha"
            exact
            component={makeDoctorUpdatePassword}
            profile={[Profile.DOCTOR]}
          />

          <PrivateRoute
            path="/novo-plano-terapeutico/exames-laudos"
            exact
            component={makeDoctorTherapeuticPlanAttachments}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/novo-plano-terapeutico/protocolo-proposto"
            exact
            component={TherapeuticPlanProposedProtocol}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/upload/documentos/:type"
            exact
            component={AppendSurgicalOrderDocument}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/upload/laudos"
            exact
            component={MedicalReports}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido-anexo"
            exact
            component={SurgicalOrderDocuments}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/laudos"
            exact
            component={MedicalReports}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/cirurgia"
            component={SurgeryDetails}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/agendamento-cirurgico/detalhes"
            component={SurgicalSchedulingDetails}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/agendamento-cirurgico"
            component={makeSurgicalSchedulingPages}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedido-cirurgico"
            component={makeSurgicalOrder}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedidos-autorizacao-ambulatorial"
            component={makeAmbulatoryAuthorizationPage}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/pedidos-cirurgicos"
            component={makeSurgicalOrderDashboard}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/integracao-pedido-cirurgico"
            exact
            component={SurgicalOrderIntegration}
            profile={[Profile.DOCTOR]}
          />
          <PrivateRoute
            path="/minhas-cirurgias"
            exact
            component={MyProductivity}
            profile={[Profile.DOCTOR]}
          />
          <Route path="/*" component={() => <Redirect to="/" />} />
        </Switch>
      )}
    </>
  )
})

const DoctorRouter = () => {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <SwitchRouter />
    </BrowserRouter>
  )
}

export default DoctorRouter
